import { render, staticRenderFns } from "./milestone-carousel-description.vue?vue&type=template&id=079178e1&scoped=true&"
import script from "./milestone-carousel-description.vue?vue&type=script&lang=ts&"
export * from "./milestone-carousel-description.vue?vue&type=script&lang=ts&"
import style0 from "./milestone-carousel-description.vue?vue&type=style&index=0&id=079178e1&lang=scss&scoped=true&"
import style1 from "./milestone-carousel-description.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "079178e1",
  null
  
)

export default component.exports